
















































































































interface addressInter {
  city: string;
  city_id: number;
  province: string;
  province_id: number;
  district: string;
  district_id: number;
  address_info: string;
  x_point: string;
  y_point: string;
}
import { getAdressApi } from "@/api/address";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import {
  BmGeolocation,
  BmLocalSearch,
  BmNavigation,
  BmMarker,
} from "vue-baidu-map";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {
    BaiduMap,
    BmGeolocation,
    BmLocalSearch,
    BmNavigation,
    BmMarker,
  },
})
export default class extends Vue {
  @Prop() originAddress!: addressInter;
  dialogVisible: boolean = false;
  zoom: number = 14;
  point = { lng: 116.404, lat: 39.915 };
  mapCenter: string | object = "北京";
  myGeo: any = null; // 地图解析方法实例
  provinceList: any[] = [];
  cityList: any[] = [];
  districtList: any[] = [];
  currentAddress: addressInter = {
    city: "",
    city_id: 0,
    province: "",
    province_id: 0,
    district: "",
    district_id: 0,
    address_info: "",
    x_point: "",
    y_point: "",
  };
  handleProvinceChange(id: number) {
    this.currentAddress.province = this.provinceList.find((item: any) => {
      return item.address_id === id;
    }).name;
    getAdressApi({ pid: id }).then((res: any) => {
      this.cityList = res.data.list;
      this.currentAddress.city = res.data.list[0].name;
      this.currentAddress.city_id = res.data.list[0].address_id;
      this.handleCityChange(res.data.list[0].address_id);
    });
  }
  handleCityChange(id: number) {
    this.currentAddress.city = this.cityList.find((item: any) => {
      return item.address_id === id;
    }).name;
    getAdressApi({ pid: id }).then((res: any) => {
      this.districtList = res.data.list;
      this.currentAddress.district = res.data.list[0].name;
      this.currentAddress.district_id = res.data.list[0].address_id;
    });
  }
  handleDistrictChange(id: number) {
    this.currentAddress.district = this.districtList.find((item: any) => {
      return item.address_id === id;
    }).name;
  }
  handleAddressInfoChange(v: string) {
    this.zoom = 18;
    this.mapCenter =
      this.currentAddress.province +
      this.currentAddress.city +
      this.currentAddress.district +
      v;
  }
  mapReady(data: any) {
    const { BMap, map } = data;
    this.myGeo = new BMap.Geocoder();
    this.mapCenter = {
      lng: this.originAddress.x_point,
      lat: this.originAddress.y_point,
    };
  }
  handleMapClick(data: any) {
    const { type, target, point, pixel, overlay } = data;
    this.point = point;
    const self = this;
    // 根据坐标逆解析获取地址详细描述
    this.myGeo.getLocation(point, function (result: any) {
      if (result) {
        self.currentAddress.province = result.addressComponents.province;
        self.currentAddress.city = result.addressComponents.city;
        self.currentAddress.district = result.addressComponents.district;
        // 通过省市区名字获取id
        const province_id = self.provinceList.find((p: any) => {
          return p.name === result.addressComponents.province;
        }).address_id;
        self.currentAddress.province_id = province_id;
        getAdressApi({ pid: province_id }).then((cres: any) => {
          self.cityList = cres.data.list;
          const city_id = cres.data.list.find((c: any) => {
            return c.name === result.addressComponents.city;
          }).address_id;
          self.currentAddress.city_id = city_id;
          getAdressApi({ pid: city_id }).then((dres: any) => {
            self.districtList = dres.data.list;
            const district_id = dres.data.list.find((d: any) => {
              return d.name === result.addressComponents.district;
            }).address_id;
            self.currentAddress.district_id = district_id;
          });
        });
        self.currentAddress.x_point = result.point.lng;
        self.currentAddress.y_point = result.point.lat;
        self.currentAddress.address_info =
          result.addressComponents.street +
          result.addressComponents.streetNumber;
      }
    });
  }
  openDialog() {
    this.currentAddress = { ...this.originAddress };
    this.point = {
      lng: Number(this.originAddress.x_point),
      lat: Number(this.originAddress.y_point),
    };
    this.zoom = 15;
    if (this.myGeo) {
      this.mapCenter = {
        lng: this.originAddress.x_point,
        lat: this.originAddress.y_point,
      };
    } else {
      this.mapCenter =
        this.originAddress.province +
        this.originAddress.city +
        this.originAddress.district;
    }
    this.dialogVisible = true;
    // 获取当前地址省市区列表
    getAdressApi({}).then((pRes: any) => {
      this.provinceList = pRes.data.list;
      getAdressApi({
        pid: this.originAddress.province
          ? this.originAddress.province_id
          : pRes.list[0].address_id,
      }).then((cRes: any) => {
        this.cityList = cRes.data.list;
        getAdressApi({
          pid: this.originAddress.city
            ? this.originAddress.city_id
            : cRes.list[0].address_id,
        }).then((dRes: any) => {
          this.districtList = dRes.data.list;
        });
      });
    });
    this.handleAddressInfoChange(this.currentAddress.address_info);
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    this.$emit("change", this.currentAddress);
    this.handleClose();
  }
}
